module.exports = __webpack_public_path__ + "static/media/Thirsk-Carved-Italic-by-TTF.bf17c6b9.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Thirsk-Carved-Italic-by-TTF.eot
// module id = 2978
// module chunks = 68